// extracted by mini-css-extract-plugin
export default {"root":"IconManufacturer_root__EtfAN"};